import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { ContentEditPopupPage } from '../content-edit-popup/content-edit-popup.page';
import { WorkstepContent } from '../workstep-content/workstep-content.component';

@Component({
    selector: 'app-multiple-content',
    templateUrl: './multiple-content.page.html',
    styleUrls: ['./multiple-content.page.scss'],
    standalone: false
})
export class MultipleContentPage implements OnInit {

  @Input() taskId: number 
  @Input() content: WorkstepContent[] = []
  public contentOnEditID: number = -1

  constructor(
    private modalCtrl: ModalController,
    private feedback: FeedbackService
  ) { }

  ngOnInit() {}

  public async closeModel(){
    await this.modalCtrl.dismiss()
  }

  public async newContent(){
    this.contentOnEditID = -1
    await this.feedback.openModal<WorkstepContent>(ContentEditPopupPage, {content: null, isNew: true, isModal: true, taskId: this.taskId}, (result: HttpFunctionResult<WorkstepContent>)=>{
      if(!result.success) return
      this.content.push(result.data)
    })
  }


  public delete(content: WorkstepContent){
    this.content.splice(this.content.indexOf(content), 1)
  }

  public async onWorkstepContentEdit(event: WorkstepContent){
    if(event == null) return
    await this.feedback.openModal<WorkstepContent>(ContentEditPopupPage, {content: event, isNew: false, isModal: true, taskId: this.taskId}, ()=>{})

  }


}
